import Modal from '../custom/Modal';
import ModalClose from './ModalClose';
import { useAppTranslation } from '../../i18n';
import { useDispatch } from 'react-redux';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';
import PrivacyModalCustomization from '../customizations/PrivacyModalCustomization';

const PrivacyModal = () => {
	const dispatch = useDispatch();
	const { t } = useAppTranslation();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.PRIVACY_MODAL));
	};

	return (
		<Modal onClose={handleOnCloseModal} ariaLabel={t('footer.privacy')}>
			<ModalClose onClose={handleOnCloseModal} />
			<PrivacyModalCustomization />
		</Modal>
	);
};

export default PrivacyModal;
